function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "scale(1.6667)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("path", {
  d: "m15.182 8.818-6.364 6.363"
}), /*#__PURE__*/React.createElement("path", {
  d: "m8.818 8.818 6.364 6.363"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 12,0.75c6.213,0,11.25,5.037,11.25,11.25 S18.213,23.25,12,23.25S0.75,18.213,0.75,12S5.787,0.75,12,0.75z"
}));

var SvgRemoveCircle = function SvgRemoveCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRemoveCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/remove_circle.d6a1f672.svg";
export { ForwardRef as ReactComponent };